<template>
  <div class="achievement">
    <div class="tab">
      <span :class="activeTab==1?'activeTab':''"
            @click="tab(1)">未提交</span>
      <span :class="activeTab==2?'activeTab':''"
            @click="tab(2)">已提交</span>
    </div>
    <div class="search">
      <div class="searchLet">
        <span>全部作业</span>
      </div>
      <div class="search_inp">
        <input type="text"
               placeholder="请输入课程名称"
               v-model="title" />
        <div @click="toMore(type,1)"
             class="searchBnt"></div>
      </div>
    </div>
    <div class="carList">
      <div class="item">
        <div class="item-title"
             @click="listShow(1)">
          <span>医疗器械行业协会注册专员能力水平考试</span>
          <span class="bnt">点击答题</span>
        </div>
      </div>
      <div>
        <div class="item-title"
             @click="listShow(2)">
          <span>医疗器械行业协会注册助理专业能力水平…</span>
          <span class="score">
            <span class>85</span>
            <span>分</span>
          </span>
        </div>
      </div>
    </div>
    <div class="popBox"
         v-show="popV">
      <div class="wrap">
        <i class="close"
           @click="popV=false"></i>
        <div class="wrap-header">
          <span>考试说明</span>
        </div>
        <div class="wrap-content">
          <span>这里显示的是考试说明的内容，根据后台管理中编辑的内容展示。这里显示的是考试说明的内容，根据后台管理中编辑的内容展示。这里显示的</span>
        </div>
        <div class="wrap-header">
          <span>考试前提</span>
        </div>
        <div>
          <div class="list-title">
            <span>考试之前，您需学习完以下课程：</span>
          </div>
          <ul>
            <li class="item">
              Lvis密网支架辅助栓塞颅内宽颈动脉…
              <span class="itemBnt">去学习</span>
            </li>
            <li class="item">
              Lvis密网支架辅助栓塞颅内宽颈动脉…
              <span class="itemBnt">去学习</span>
            </li>
            <li class="item">
              Lvis密网支架辅助栓塞颅内宽颈动脉…
              <span class="itemBnt">去学习</span>
            </li>
            <li class="item">
              Lvis密网支架辅助栓塞颅内宽颈动脉…
              <span class="itemBnt">去学习</span>
            </li>
          </ul>
        </div>
        <div class="sure">
          <span>确定</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import iVideolist from "../container/videoList";
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from '../../AppSetting';
export default {
  data () {
    return {
      activeTab: 1,
      itemId: 1,
      wxuser: null,
      popV: true
    };
  },
  props: {},
  async mounted () {
    this. wxuser=await loginService.getLoginUser();
    document.title = "考试中心";
    // this.$postHttp(AppSetting.baseUrl + '/student/complete/video',{uid:this.wxuser.uId,}).then((res)=>{
    //   if(res.data.code==0){
    //     this.video_hottest = res.data.list;
    //   }
    // })
    this.getList();
  },
  methods: {
    listShow (val) {
      this.itemId = val;
      // this.getList()
    },
    tab (val) {
      this.activeTab = val;
      this.getList();
    },
    getList () {
      this.$postHttp(AppSetting.baseUrl + "/achievement/app/list", {
        amUId: this.wxuser.uId,
        amType: this.activeTab
      }).then(res => {
        if (res.data.code == 0) {
          // this.certificateList = res.data.list;
        }
      });
    }
  },
  components: {},
  computed: {}
};
</script>
<style scoped lang="scss">
.achievement {
  width: 100%;
  height: 100%;
  background: #f4f5f4;
  min-height: 100vh;

  .tab {
    width: 100%;
    display: flex;
    font-size: 0.3rem;
    color: #333;
    text-align: center;
    line-height: 0.8rem;
    background: #fff;
    padding: 0px 0.3rem;
    box-sizing: border-box;
    span {
      flex: 1;
      padding: 0px 0.15rem;
      box-sizing: border-box;
    }
  }
  .activeTab {
    color: #05a2ff;
    font-size: 0.34rem;
    border-bottom: 0.01rem solid #05a2ff;
  }
  .search {
    padding: 0.33rem 0.29rem;
    box-sizing: border-box;
    overflow: hidden;
    .searchLet {
      float: left;
      width: 20%;
      font-size: 0.3rem;
      color: #333;
      line-height: 0.7rem;
    }
    .search_inp {
      float: left;
      height: 0.7rem;
      line-height: 0.7rem;
      width: 80%;
      position: relative;
      padding-right: 0.15rem;
      // border-radius: 0.15rem;
      box-sizing: border-box;
      // background:rgba(238,238,238,1);
      input {
        background: none;
        outline: none;
        border: none;
        display: inline-block;
        position: absolute;
        top: 0px;
        left: 0.3rem;
        width: 98%;
        height: 90%;
        outline: none;
        border-radius: 0.15rem;
        box-sizing: border-box;
        padding: 0 0.3rem;
        background: rgba(238, 238, 238, 1);
      }
      .searchBnt {
        width: 0.28rem;
        height: 0.28rem;
        position: absolute;
        right: 0.15rem;
        top: 50%;
        margin-top: -0.14rem;
        // background: url("../../assets/images/search.png");
        background-size: 100% 100%;
      }
    }
  }
  .carList {
    .item {
      padding-bottom: 0.12rem;
    }
    .item-title {
      font-size: 0.3rem;
      color: #333333;
      line-height: 1.04rem;
      background: #fff;
      padding: 0px 0.3rem;
      box-sizing: border-box;
      position: relative;
      // borde-bottom: 0.01rem solid #
      .bnt {
        font-size: 0.22rem;
        background: #05a2ff;
        color: #fff;
        border-radius: 0.1rem;
        padding: 0rem 0.05rem;
        height: 0.39rem;
        line-height: 0.39rem;
        position: absolute;
        top: 0px;
        bottom: 0px;
        margin: auto;
        right: 0.1rem;
      }
      .score {
        float: right;
        :first-child {
          font-size: 0.5rem;
          color: #ff0000;
        }
      }
    }
  }
  .popBox {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    background: rgba(0, 0, 0, 0.5);
    padding: 1.56rem 0.56rem 0px;
    box-sizing: border-box;

    .wrap {
      padding: 0.35rem 0px;
      width: 80%;
      border-radius: 0.15rem;
      margin: auto;
      background: #fff;
      font-size: 0.26rem;
      color: #535353;
      position: relative;
      .close {
        display: inline-block;
        width: 0.35rem;
        height: 0.35rem;
        background: url("../../assets/images/close.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        right: 0.15rem;
        top: 0.15rem;
      }
      .wrap-header {
        font-size: 0.33rem;
        color: #05a2ff;
        text-align: center;
        padding: 0.35rem 0rem;
      }
      .wrap-content {
        width: 95%;
        margin: auto;
        padding: 0.3rem;
        box-sizing: border-box;
        border: 0.01rem solid rgba(229, 229, 229, 1);
        border-radius: 0.15rem;
      }
      .list-title {
        font-size: 0.26rem;
        color: #000000;
        border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
        line-height: 0.83rem;
        padding: 0rem 0.32rem;
        box-sizing: border-box;
      }
      .item {
        font-size: 0.26rem;
        color: #535353;
        border-bottom: 0.01rem solid rgba(229, 229, 229, 1);
        line-height: 0.83rem;
        padding: 0rem 0.32rem;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 1rem;
        position: relative;
      }
      .itemBnt {
        position: absolute;
        top: 0px;
        bottom: 0px;

        margin: auto;
        right: 0.1rem;
        float: right;
        font-size: 0.24rem;
        color: #fff;
        background: #f5b53a;
        height: 0.34rem;
        line-height: 0.34rem;
        padding: 0rem 0.05rem;
        border-radius: 0.05rem;
      }
      .sure {
        font-size: 0.32rem;
        color: #fff;
        background: #05a2ff;
        width: 3.2rem;
        margin: auto;
        line-height: 0.8rem;
        text-align: center;
        border-radius: 0.15rem;
        margin-top: 0.35rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/examination.vue